var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 8.36683C15.8451 6.94826 15.0813 5.67088 13.9642 4.75287C12.8471 3.83486 11.4459 3.33317 10 3.3335C7.59167 3.3335 5.5 4.70016 4.45833 6.70016C3.23353 6.83252 2.10084 7.41284 1.27791 8.3296C0.454976 9.24636 -0.000143085 10.4349 3.3744e-08 11.6668C3.3744e-08 14.4252 2.24167 16.6668 5 16.6668H15.8333C18.1333 16.6668 20 14.8002 20 12.5002C20 10.3002 18.2917 8.51683 16.125 8.36683ZM11.6667 10.8335V14.1668H8.33333V10.8335H5.83333L10 6.66683L14.1667 10.8335H11.6667Z",
    fill: "#228BE6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadMore);
export default __webpack_public_path__ + "static/media/uploadMore.0bf1aac7d2d98570ab4177c4bdce6427.svg";
export { ForwardRef as ReactComponent };